import { ReactNode } from 'react';
import AttentionPanel from '@/components/ui/AttentionPanel.tsx';
import { AttentionItemDto } from '@/types/stats/AttentionItemDto.ts';
import { toAttentionPanelItems } from '@/features/dashboard/attention/types/AttentionKey.utils.ts';
import { AttentionLinkScope } from '@/features/dashboard/attention/routes/attentionLinks.ts';

interface DeferredAttentionListProps
  extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  meta?: ReactNode;
  headerAction?: ReactNode;
  items: AttentionItemDto[];
  scope: AttentionLinkScope;
  onReopen: (item: AttentionItemDto) => void;
}

/** Odłożone sprawy: te same wiersze w tonie neutralnym, pod zdaniem audyt, w menu „Przywróć”. */
const DeferredAttentionList = ({
  title,
  meta,
  headerAction,
  items,
  scope,
  onReopen,
  ...props
}: DeferredAttentionListProps) => (
  <AttentionPanel
    title={title}
    meta={meta}
    headerAction={headerAction}
    emptyDescription="Nic nie jest odłożone."
    items={toAttentionPanelItems(items, { scope, onReopen })}
    {...props}
  />
);

export default DeferredAttentionList;
